import FixedFormSection from "./FixedFormSection";

export const FixedFormTab = ({ tab, fieldMap }) => {
  console.log("TAB", tab);
  return (
    <form className="ui form" style={{ paddingBottom: "80px" }}>
      {Object.entries(tab).map(([tabName, sec], i) => {
        return <FixedFormSection key={i} section={sec} fieldMap={fieldMap} />;
      })}
    </form>
  );
};

export default FixedFormTab;
